import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageLocationService {

  constructor(private _httpClient: IesHttpClient) {
  }

  getSearchedLocation(urlParams: any) {
    return this._httpClient.get(AppUrl.searchLocationsByFilter, urlParams);

  }

  // fetch location data based on Id
  getLocation(id: number) {
    return this._httpClient.get(AppUrl.getLocationDetail, id);
  }

  //Save, Update Location
  saveLocation(params: any) {
    return this._httpClient.post(AppUrl.addLocationDetail, params);

  }


}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-manage-location.service.ts